import React from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { IconPlus } from "@tabler/icons-react";

import BreadCrumbs from "@components/breadCrumbs/breadCrumbs";
import CustomTabs from "@components/tabs/customTabs";
import CustomButton from "@components/button/customButton";

import Role from "./role/role";
import User from "./user/user";

export default function Security() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  return (
    <div>
      <BreadCrumbs 
        rightSection={
          <CustomButton 
            component={RouterLink} 
            startIcon={<IconPlus size={13} />}
            to={tab === 'users' ? 'create-user' : 'create-role'} 
          >
            Create
          </CustomButton>
        }
      />
      <CustomTabs
        tabs={[
          {
            label: "Roles",
            value: "roles",
            component: (
              <Role />
            ),
          },
          {
            label: "Users",
            value: "users",
            component: (
              <User />
            ),
          },
        ]}
      />
    </div>
  );
}